import i18next from "i18next";
import { action, makeObservable, observable } from "mobx";

import { fetchConfigFileWithDefault } from "../fetchConfig";

const DEFAULT_STATIC_LABELS = {
  KIE: {
    Heading: {
      NonGroupResult: [i18next.t("common.results"), true],
      GroupResult: [i18next.t("common.table"), true],
    },
  },
  Common: {
    Button: {
      Download: [i18next.t("actions.download"), true],
      Submit: [i18next.t("actions.submit"), false],
    },
    Message: {
      FileFormat: [i18next.t("demo_select.file_format"), true],
      FileSize: [i18next.t("demo_select.file_size_limit"), true],
      SecurityWarning: [i18next.t("demo_select.demo_warning"), true],
      DemoSecurityWarning: [
        i18next.t("demo_select.demo_security_warning"),
        true,
      ],
      FirstPageWarning: [i18next.t("demo_select.first_page_warning"), false],
    },
  },
};

class StaticLabelStore {
  staticLabels: any = {};

  setStaticLabels(value: object) {
    this.staticLabels = value;
  }

  async fetchStaticLabels() {
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const staticLabels = await fetchConfigFileWithDefault(
      "StaticLabel.json",
      DEFAULT_STATIC_LABELS,
      serverUrl,
    );
    this.setStaticLabels(staticLabels);
  }

  constructor() {
    makeObservable(this, {
      staticLabels: observable,
      setStaticLabels: action,
    });
    this.setStaticLabels = this.setStaticLabels.bind(this);
    this.fetchStaticLabels();
  }
}

export const staticLabelStore = new StaticLabelStore();
